import { favoriteStorage } from "@/client/data/storage";
import "./itemPage.css";
import { getItemIconUrl } from "@/client/util/wowhead";
import { useEffect, useState } from "react";
import type { LocalItemEntry } from "@/client/data/ItemCache";

const ItemHeader = ({ itemData }: { itemData: LocalItemEntry }): JSX.Element => {
    const [isFav, setIsFav] = useState<boolean>();

    useEffect(() => {
        const onFavChange = () => {
            const favData = favoriteStorage.getEntry("favs");
            setIsFav(!!favData.find((v) => v.itemId == itemData.itemId));
        };

        favoriteStorage.addOnChange(onFavChange);
        onFavChange();

        return () => {
            favoriteStorage.removeOnChange(onFavChange);
        };
    }, []);

    const favBtnClasses = ["button", "itemPageHeaderFavBtn"];
    if (isFav) favBtnClasses.push("isFav");

    const toggleFav = () => {
        const favData = favoriteStorage.getEntry("favs");
        const favIdx = favData.findIndex((v) => v.itemId == itemData.itemId);
        if (favIdx !== -1) {
            favData.splice(favIdx, 1);
        } else {
            favData.push({
                itemId: itemData.itemId,
                itemName: itemData.itemName,
                qualityId: itemData.qualityId,
                iconName: itemData.iconName,
                iconId: itemData.iconId,
            });
        }
        favoriteStorage.setEntry("favs", favData);
    };

    return (
        <div className="itemPageItemHeader">
            <img className="itemIcon itemPageItemHeaderIcon" src={getItemIconUrl(itemData.iconName, "large")}></img>
            <h1 className={`itemQuality${itemData.qualityId} itemPageItemHeaderName`}>{itemData.itemName}</h1>
            <button className={favBtnClasses.join(" ")} onClick={toggleFav}>
                {isFav ? "Remove Favorite" : "Add Favorite"}
            </button>
        </div>
    );
};

export default ItemHeader;
